<template>
  <section class="services container">
    <h2>{{ services.title }}</h2>
    <div v-html="services.description" class="mb-4"></div>
    <div class="row">
      <ServiceCard class="col-12 col-sm-6 col-lg-3" v-for="card in services.articles" :card="card" :key="card.id" />
    </div>
  </section>
</template>

<script>
import ServiceCard from "@/components/services/ServiceCard";
export default {
  components: {ServiceCard},
  props: {
    services: {
      title: String,
      description: String,
      articles: Array
    }
  }
}
</script>
